import { dashboardT } from '../../../../../../lib/messages';
import type { JourneyTimeRange } from './journeyFlowModel';
import { journeyTimeRanges } from './journeyFlowModel';

const minute = 60_000;
const day = 24 * 60 * minute;
export function journeyWindowBounds(now = Date.now()) {
  return {
    min: Math.floor((now - 35 * day) / (15 * minute)) * 15 * minute + 15 * minute,
    max: Math.floor(now / minute) * minute,
  };
}
export function recentJourneyWindow(range: JourneyTimeRange, now = Date.now()) {
  const to = journeyWindowBounds(now).max;
  const minutes = journeyTimeRanges.find(({ id }) => id === range)?.minutes ?? 1440;
  return { from: new Date(to - minutes * minute).toISOString(), to: new Date(to).toISOString() };
}
export function utcJourneyInput(instant: string | number) {
  return new Date(instant).toISOString().slice(0, 16);
}
export function journeyInputInstant(value: string) {
  return new Date(`${value}Z`);
}
export function validateJourneyWindow(from: string, to: string, now = Date.now()): string | null {
  const start = new Date(from).getTime();
  const end = new Date(to).getTime();
  const bounds = journeyWindowBounds(now);
  if (!Number.isFinite(start) || !Number.isFinite(end)) return dashboardT('journey.invalidDates');
  if (start % minute || end % minute) return dashboardT('journey.minuteAligned');
  if (end <= start || end - start > 7 * day) return dashboardT('journey.invalidRange');
  if (start < bounds.min) return dashboardT('journey.retention');
  if (end > bounds.max) return dashboardT('journey.future');
  return null;
}
